<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';

import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
    extras: null,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  created(){
    // console.log("extras", this.extras);
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_SALE_PRODUCT_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.dummySaleOrderProduct;
          this.extraData = response.data;
          // console.log("---", this.extras);
          this.extraData.customerId = this.extras.customerId;
          this.extraData.paymentConditionRuleId = this.extras.paymentConditionRuleId;
          this.extraData.accountContext.accountPermissions = this.extras.accountContext.accountPermissions;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_SALE_PRODUCT_QUERY = gql `
  {
    accountContext {
      dummySaleOrderProduct {
        id
        quantity
        price
        unitPrice
        packagingQuantity
        itemId
        item {
          id
        }
        packagingId
        packaging {
          id
        }
        storageId
        storage {
          id
        }
        isNewItemInStorage
        validations
      }
      allStorages {
        id
        name
        location
      }
      availableItemsForSale {
        id
        name
        unit {
          id
          name
        }
      }
    }
  }
`;

</script>

<style scoped></style>
